import type { SVGProps } from 'react'

export const MoreIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      {...props}
    >
      {/* Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE */}
      <path
        fill='currentColor'
        d='M6 14q-.825 0-1.412-.587T4 12t.588-1.412T6 10t1.413.588T8 12t-.587 1.413T6 14m6 0q-.825 0-1.412-.587T10 12t.588-1.412T12 10t1.413.588T14 12t-.587 1.413T12 14m6 0q-.825 0-1.412-.587T16 12t.588-1.412T18 10t1.413.588T20 12t-.587 1.413T18 14'
      />
    </svg>
  )
}

export const DeleteIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      {...props}
    >
      {/* Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE */}
      <path
        fill='currentColor'
        d='M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z'
      />
    </svg>
  )
}
export const ChatBotIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='64'
      height='64'
      viewBox='0 0 64 64'
      fill='none'
    >
      <rect width='64' height='64' rx='32' fill='black' />
      <path
        d='M45.3333 29.3334V33.3334C45.3333 38.6667 42.6666 41.3334 37.3333 41.3334H36.6666C36.2533 41.3334 35.8533 41.5334 35.6 41.8667L33.6 44.5334C32.72 45.7067 31.28 45.7067 30.4 44.5334L28.4 41.8667C28.1866 41.5734 27.6933 41.3334 27.3333 41.3334H26.6666C21.3333 41.3334 18.6666 40 18.6666 33.3334V26.6667C18.6666 21.3334 21.3333 18.6667 26.6666 18.6667H34.6666'
        stroke='white'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M42 25.3334C43.8409 25.3334 45.3333 23.841 45.3333 22C45.3333 20.1591 43.8409 18.6667 42 18.6667C40.159 18.6667 38.6666 20.1591 38.6666 22C38.6666 23.841 40.159 25.3334 42 25.3334Z'
        fill='#838383'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.3287 30.6667H37.3406'
        stroke='white'
        strokeWidth='2.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M31.9939 30.6667H32.0059'
        stroke='white'
        strokeWidth='2.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.6593 30.6667H26.6713'
        stroke='white'
        strokeWidth='2.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const ChatDownIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='55'
      height='55'
      viewBox='0 0 65 64'
      fill='none'
    >
      <rect x='0.467773' width='64' height='64' rx='32' fill='black' />
      <path
        d='M32.4687 38.3999C33.4021 38.3999 34.3354 38.0399 35.0421 37.3332L43.7354 28.6399C44.1221 28.2532 44.1221 27.6132 43.7354 27.2265C43.3487 26.8399 42.7087 26.8399 42.3221 27.2265L33.6287 35.9199C32.9887 36.5599 31.9487 36.5599 31.3087 35.9199L22.6154 27.2265C22.2287 26.8399 21.5887 26.8399 21.2021 27.2265C20.8154 27.6132 20.8154 28.2532 21.2021 28.6399L29.8954 37.3332C30.6021 38.0399 31.5354 38.3999 32.4687 38.3999Z'
        fill='white'
      />
    </svg>
  )
}

export const ChatBotLogo = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='37'
      height='36'
      viewBox='0 0 37 36'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M26.4085 18.8164C24.3842 19.6281 22.1991 20.1287 19.9137 20.2584C19.5196 20.2808 19.1225 20.2921 18.7227 20.2921C18.3229 20.2921 17.9257 20.2808 17.5316 20.2584C15.2456 20.1287 13.0601 19.6279 11.0353 18.8159C6.78634 17.1119 3.24578 14.0374 0.972656 10.1461C4.51571 4.08073 11.1379 0 18.7227 0C26.3074 0 32.9296 4.08073 36.4727 10.1461C34.1993 14.0378 30.6582 17.1125 26.4085 18.8164Z'
        fill='white'
      />
      <path
        d='M11.0348 20.3954C10.5453 20.1991 10.0652 19.9846 9.5954 19.7527C8.06846 20.8179 6.77764 22.1446 5.80566 23.6582C7.45777 26.2308 10.0311 28.2634 13.1192 29.39C14.5908 29.9269 16.1793 30.258 17.8407 30.3437H19.5721C21.2331 30.258 24.1526 31.8876 19.9132 35.9999C23.0019 34.8734 29.9548 26.2311 31.6071 23.6582C30.6379 22.1489 29.3517 20.8255 27.8304 19.7619C27.366 19.9904 26.8916 20.2021 26.408 20.396C24.3837 21.2076 22.1986 21.7082 19.9132 21.8379C19.5191 21.8603 19.1219 21.8716 18.7221 21.8716C18.3223 21.8716 17.9252 21.8603 17.5311 21.8379C15.2451 21.7082 13.0595 21.2074 11.0348 20.3954Z'
        fill='white'
      />
      <rect
        x='10.1641'
        y='7.5506'
        width='17.1556'
        height='6.06741'
        rx='3.03371'
        fill='#162550'
      />
      <ellipse
        cx='23.4729'
        cy='10.5507'
        rx='1.12328'
        ry='1.11236'
        fill='#04FED1'
      />
      <ellipse
        cx='18.7073'
        cy='25.5168'
        rx='1.12328'
        ry='1.11236'
        fill='#162550'
      />
      <ellipse
        cx='14.2141'
        cy='10.5507'
        rx='1.12328'
        ry='1.11236'
        fill='#04FED1'
      />
      <ellipse
        cx='14.2141'
        cy='25.5168'
        rx='1.12328'
        ry='1.11236'
        fill='#162550'
      />
      <ellipse
        cx='23.2004'
        cy='25.5168'
        rx='1.12328'
        ry='1.11236'
        fill='#162550'
      />
    </svg>
  )
}
export const CloseIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <path
        d='M12.3877 22C17.8877 22 22.3877 17.5 22.3877 12C22.3877 6.5 17.8877 2 12.3877 2C6.8877 2 2.3877 6.5 2.3877 12C2.3877 17.5 6.8877 22 12.3877 22Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.3877 12H16.3877'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const LoaderIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
      <defs>
        <radialGradient
          id='a12'
          cx='0.66'
          fx='0.66'
          cy='0.3125'
          fy='0.3125'
          gradientTransform='scale(1.5)'
        >
          <stop offset='0' stopColor='#000000' />
          <stop offset='0.3' stopColor='#000000' stopOpacity='0.9' />
          <stop offset='0.6' stopColor='#000000' stopOpacity='0.6' />
          <stop offset='0.8' stopColor='#000000' stopOpacity='0.3' />
          <stop offset='1' stopColor='#000000' stopOpacity='0' />
        </radialGradient>
      </defs>

      <circle
        fill='none'
        stroke='url(#a12)'
        strokeWidth='13'
        strokeLinecap='round'
        strokeDasharray='200 1000'
        strokeDashoffset='0'
        cx='100'
        cy='100'
        r='70'
      >
        <animateTransform
          attributeName='transform'
          type='rotate'
          from='0 100 100'
          to='360 100 100'
          dur='2s'
          repeatCount='indefinite'
        />
      </circle>

      <circle
        fill='none'
        opacity='0.2'
        stroke='#000000'
        strokeWidth='13'
        strokeLinecap='round'
        cx='100'
        cy='100'
        r='70'
      />
    </svg>
  )
}

export const SendBtnIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
    >
      <path
        d='M9.97804 4.22989L18.538 8.50989C22.378 10.4299 22.378 13.5699 18.538 15.4899L9.97804 19.7699C4.21804 22.6499 1.86804 20.2899 4.74804 14.5399L5.61804 12.8099C5.83804 12.3699 5.83804 11.6399 5.61804 11.1999L4.74804 9.45989C1.86804 3.70989 4.22804 1.34989 9.97804 4.22989Z'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.9082 12H11.3082'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const CloseWarningIcon = () => {
  return (
    <svg className='h-4 w-4' fill='currentColor' viewBox='0 0 20 20'>
      <path
        fillRule='evenodd'
        d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 011.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export const WarningIcon = () => {
  return (
    <svg
      className='h-5 w-5 mt-0.5 mr-2 text-yellow-500'
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M12 9v2m0 4h.01M4.93 4.93l14.14 14.14M1 12c0-6.075 4.925-11 11-11s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z'
      />
    </svg>
  )
}
export const TypingLoader = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
      <circle
        fill='#0B0105'
        stroke='#0B0105'
        strokeWidth='15'
        r='15'
        cx='40'
        cy='100'
      >
        <animate
          attributeName='opacity'
          calcMode='spline'
          dur='2'
          values='1;0;1;'
          keySplines='.5 0 .5 1;.5 0 .5 1'
          repeatCount='indefinite'
          begin='-.4'
        />
      </circle>
      <circle
        fill='#0B0105'
        stroke='#0B0105'
        strokeWidth='15'
        r='15'
        cx='100'
        cy='100'
      >
        <animate
          attributeName='opacity'
          calcMode='spline'
          dur='2'
          values='1;0;1;'
          keySplines='.5 0 .5 1;.5 0 .5 1'
          repeatCount='indefinite'
          begin='-.2'
        />
      </circle>
      <circle
        fill='#0B0105'
        stroke='#0B0105'
        strokeWidth='15'
        r='15'
        cx='160'
        cy='100'
      >
        <animate
          attributeName='opacity'
          calcMode='spline'
          dur='2'
          values='1;0;1;'
          keySplines='.5 0 .5 1;.5 0 .5 1'
          repeatCount='indefinite'
          begin='0'
        />
      </circle>
    </svg>
  )
}
export const PlusCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      {...props}
    >
      {/* Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE */}
      <path
        fill='currentColor'
        d='M11 13v3q0 .425.288.713T12 17t.713-.288T13 16v-3h3q.425 0 .713-.288T17 12t-.288-.712T16 11h-3V8q0-.425-.288-.712T12 7t-.712.288T11 8v3H8q-.425 0-.712.288T7 12t.288.713T8 13zm1 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22'
      />
    </svg>
  )
}

export const CloseCirleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      {...props}
    >
      {/* Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE */}
      <path
        fill='currentColor'
        d='m12 13.4l2.9 2.9q.275.275.7.275t.7-.275t.275-.7t-.275-.7L13.4 12l2.9-2.9q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275L12 10.6L9.1 7.7q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7l2.9 2.9l-2.9 2.9q-.275.275-.275.7t.275.7t.7.275t.7-.275zm0 8.6q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8'
      />
    </svg>
  )
}

export const DownloadIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 24 24'
      {...props}
    >
      {/* Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE */}
      <path
        fill='currentColor'
        d='m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z'
      />
    </svg>
  )
}
